// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selected-products {
    margin-bottom: 20px;
    padding: 15px;
    background: #f8f9fa;
    border-radius: 4px;
}

.selected-products h4 {
    margin: 0 0 10px 0;
    color: #333;
}

.selected-products ul {
    margin: 0;
    padding-left: 20px;
    max-height: 150px;
    overflow-y: auto;
}

.selected-products li {
    margin-bottom: 5px;
    color: #666;
}
[data-theme="dark"] .selected-products { background: #222f28; }
[data-theme="dark"] .selected-products h4 { color: #e3ece6; }
[data-theme="dark"] .selected-products li { color: #9fb0a6; }

.bulk-editor-form {
    margin-top: 20px;
}

.bulk-editor-actions {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
}

@media (max-width: 768px) {

    .bulk-editor-actions {
        flex-direction: column;
        gap: 10px;
    }

    .bulk-editor-actions button {
        width: 100%;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/ProductBulkEditor.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;AACA,yCAAyC,mBAAmB,EAAE;AAC9D,4CAA4C,cAAc,EAAE;AAC5D,4CAA4C,cAAc,EAAE;;AAE5D;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,yBAAyB;AAC7B;;AAEA;;IAEI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,WAAW;IACf;AACJ","sourcesContent":[".selected-products {\n    margin-bottom: 20px;\n    padding: 15px;\n    background: #f8f9fa;\n    border-radius: 4px;\n}\n\n.selected-products h4 {\n    margin: 0 0 10px 0;\n    color: #333;\n}\n\n.selected-products ul {\n    margin: 0;\n    padding-left: 20px;\n    max-height: 150px;\n    overflow-y: auto;\n}\n\n.selected-products li {\n    margin-bottom: 5px;\n    color: #666;\n}\n[data-theme=\"dark\"] .selected-products { background: #222f28; }\n[data-theme=\"dark\"] .selected-products h4 { color: #e3ece6; }\n[data-theme=\"dark\"] .selected-products li { color: #9fb0a6; }\n\n.bulk-editor-form {\n    margin-top: 20px;\n}\n\n.bulk-editor-actions {\n    display: flex;\n    gap: 10px;\n    justify-content: flex-end;\n}\n\n@media (max-width: 768px) {\n\n    .bulk-editor-actions {\n        flex-direction: column;\n        gap: 10px;\n    }\n\n    .bulk-editor-actions button {\n        width: 100%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
